import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-un-done-orders',
  templateUrl: './un-done-orders.component.html',
  styleUrls: ['./un-done-orders.component.scss']
})
export class UnDoneOrdersComponent implements OnInit {

  requestType : string = 'order';
  title : string = 'أوامر الصيانة المعلقة';
  
  constructor() { }

  ngOnInit() {
  }

}
